import SEOHead from '@/components/common/SEOHead';
import HeroBanner from '@/components/home/HeroBanner';
import FeaturedProducts from '@/components/home/FeaturedProducts';
import ServicesOverview from '@/components/home/ServicesOverview';
import Testimonials from '@/components/home/Testimonials';
import ContactCTA from '@/components/home/ContactCTA';

export default function Home() {
  return (
    <>
      <SEOHead
        description="KaamKaaj Online - Quality stationery products (notebooks, pens, textbooks, colors) and trusted digital services (printing, Aadhaar, PAN, passport, exam forms, ticket booking) under one roof."
        keywords="stationery shop, digital services, printing, photocopy, Aadhaar card, PAN card, passport, government schemes, competitive exam form, ticket booking, bulk printing, notebooks, pens, textbooks, kaamkaaj online"
      />
      <HeroBanner />
      <FeaturedProducts />
      <ServicesOverview />
      <Testimonials />
      <ContactCTA />
    </>
  );
}
